import type { CaseDetail } from '../portfolio';

const hitachiSocialCase: CaseDetail = {
  id: 'hitachi-social',
  project: 'Hitachi Social Info Service',
  client: 'Hitachi Social Info Service',
  year: 'Archive',
  category: 'Web / UX/UI / Recruitment',
  role: 'Brand Strategy / Web / UX/UI',
  issue: '社会インフラを支えるIT企業の価値が、候補者に十分に伝わっていなかった。',
  challenge: '「社会に役立つ仕事」という誇りを、候補者の具体的なキャリアとして伝えること。',
  insight: '「お客さまとともに New未来を拓く」「Both partner」——社会インフラの信頼性と、そこで働く人の成長物語が結びつくと強い。',
  strategy: '「お客さまとともに新たな未来を拓く」を採用コンセプトに、SI事業・SO事業・PS事業の3つの事業領域と、公共・通信・金融・産業・流通・ヘルスケアなど幅広いフィールドで活躍できるキャリアを伝える採用体験を設計。',
  experience: '職種・事業紹介、エンジニアの物語、応募導線まで一貫した体験を設計。',
  output: 'Brand Concept / Web / UX/UI / Content',
  impact: '社会価値の理解と、候補者の応募意思向上を実現。',
  images: [
    {
      src: '/assets/migrated/a79e6e10e124f2700184.webp',
      caption: '採用サイト・デザイン案 — 見易さの追求・スマートフォン版 / 総括',
    },
    {
      src: '/assets/migrated/6834e040447a33ea5719.webp',
      caption: '採用サイト全体像 — PC版・スマートフォン版の2パターン展開',
    },
    {
      src: '/assets/migrated/6933f85f88ab9946c7f1.webp',
      caption: 'ターゲットアプローチ分析 — マインドMAP・コミュニケーションセグメント・コミュニケーションコンセプト',
    },
    {
      src: '/assets/migrated/d1f200f4c4cf5e02b8d6.webp',
      caption: '採用サイト実装版 — 社員紹介セクションを含む全ページ構成',
    },
    {
      src: '/assets/migrated/588bcc7b6812bcf9a261.webp',
      caption: '新入社員座談会 — 2018年度新入社員のキャリアストーリーQ&A',
    },
    {
      src: '/assets/migrated/3b9a08753ae6cf91b489.webp',
      caption: '採用サイトデザイン展開 — ターゲットアプローチからキービジュアル・サイト構造設計',
    },
    {
      src: '/assets/migrated/17f4cd5ea8640e23a484.webp',
      caption: '採用サイトTOPページ — 「お客さまとともに未来を拓く。」SI・SO・PS事業紹介・エントリー',
    },
    {
      src: '/assets/migrated/9cb5f87dff2106efe562.webp',
      caption: '採用メッセージページ — 人財マネジメント部長メッセージ・社員インタビュー・エントリー導線',
    },
    {
      src: '/assets/migrated/b84196332c5800535908.webp',
      caption: '採用サイトデザイン案（2ページ展開）— ヒーロー・事業紹介・プロジェクト・エントリーまでの全体構成',
    },
    {
      src: '/assets/migrated/d94546f776ea089a0fbd.webp',
      caption: '採用サイトTOPページ（別バリエーション）— SI・SO・PS事業の異なるビジュアル表現',
    },
    {
      src: '/assets/migrated/e56a60653f39575a0859.webp',
      caption: 'ターゲットインサイト分析 — 就活生マインドMAP・コミュニケーションセグメント・採用課題抽出',
    },
    {
      src: '/assets/migrated/f50a7b82a79f45a05a40.webp',
      caption: '日立社会情報サービス WEB 採用サイト — 「お客さまとともに未来を拓く。」ヘッダー・事業紹介・プロジェクト・エントリー全体構成実組写真',
    },
  ],
};

export default hitachiSocialCase;